
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.677 51.982c-.26 0-.52-.11-.71-.289-1.45-1.433-9.588-11.867-13.918-20.03a.607.607 0 01-.05-.12h-.01a16.547 16.547 0 01-1.96-7.796c0-9.139 7.47-16.576 16.648-16.576 9.179 0 16.647 7.437 16.647 16.576 0 2.678-.66 5.347-1.92 7.716l-.03.06c0 .01-.04.07-.04.08a.4.4 0 01-.05.09c-4.319 8.133-12.457 18.557-13.907 20a.97.97 0 01-.7.289zM16.809 30.736c3.69 6.96 10.428 15.88 12.858 18.757 2.43-2.877 9.169-11.808 12.858-18.757l.06-.12c1.13-2.1 1.72-4.47 1.72-6.859 0-8.044-6.57-14.585-14.648-14.585-8.079 0-14.648 6.541-14.648 14.585 0 2.39.6 4.76 1.72 6.86.04.04.06.08.08.12z"}}),_c('path',{attrs:{"d":"M29.077 30.577c-3.78 0-6.849-3.056-6.849-6.82 0-3.763 3.07-6.82 6.849-6.82 3.78 0 6.849 3.057 6.849 6.82 0 3.764-3.07 6.82-6.849 6.82zm0-11.648c-2.68 0-4.85 2.17-4.85 4.828 0 2.659 2.18 4.829 4.85 4.829 2.67 0 4.85-2.17 4.85-4.829 0-2.658-2.17-4.828-4.85-4.828z"}})])
          )
        }
      }
    